module.exports = __webpack_public_path__ + "img/no-ki.8ce0ad1f.png";